import { render, staticRenderFns } from "./ExpoCategoriesCards.vue?vue&type=template&id=0f793e14&scoped=true&"
import script from "./ExpoCategoriesCards.vue?vue&type=script&lang=js&"
export * from "./ExpoCategoriesCards.vue?vue&type=script&lang=js&"
import style0 from "./ExpoCategoriesCards.vue?vue&type=style&index=0&id=0f793e14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f793e14",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCard, BCardGroup} from 'bootstrap-vue'
    installComponents(component, {BCard, BCardGroup})
    

export default component.exports